// src/components/Views/RepositoryView.js
import React from "react";
import "../../../css/Views/RepositoryView.css";

const sections = [
  {
    title: "📁 Dokumenty organizacyjne",
    links: [
      { label: "Folder dla osób koordynujących", url: "https://drive.google.com/drive/folders/1ute53TJ58vrw69qcaLsMEAbIBYcnydb5" },
      { label: "Planowane wycieczki", url: "https://docs.google.com/spreadsheets/d/1QPEq6ydg39p7iVht8rA-SMJKyxDNhM9Wy-qgLkBVbns" },
    ],
  },
  {
    title: "📷 Zdjęcia i materiały",
    links: [
      { label: "Lista albumów z wycieczek TD", url: "https://docs.google.com/spreadsheets/d/1dNPZDxe8nqvupmWl8dlbj3dzGOCD_BkaawggeKChPN4" },
    ],
  },
  {
    title: "📣 Komunikacja i media",
    links: [
      { label: "Harmonogram postów na Mediach Społecznościowych", url: "https://docs.google.com/spreadsheets/d/14uC9121wmlubjCo26g0mUmmG43m_SAAV" },
    ],
  },
  {
    title: "🏕️ Logistyka",
    links: [
      { label: "Polecane miejsca noclegowe", url: "https://www.google.com/maps/d/u/1/edit?mid=10goniEhr8qwjVfeJlnuEMvRj2f8xrc0" },
    ],
  },
];

const RepositoryView = () => {
  return (
    <div className="repository-container">
      <div className="repository-header">Repozytorium</div>
      {sections.map((section, idx) => (
        <div className="repository-section" key={idx}>
          <h3 className="repository-section-title">{section.title}</h3>
          <ul className="repository-list">
            {section.links.map((link, i) => (
              <li key={i}>
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                📂 {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RepositoryView;
